import React, { memo } from 'react'
import ControlledRadioGroupInput from 'transfix-form/components/ControlledRadioGroupInput'
import { FormHelperText } from 'transfix-ui/core'
import Typography from 'transfix-ui/core/Typography'
import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import { useCreateShipmentFormContext } from 'apps/marketplace/pages/create-shipment/context'
import { TReeferSchema } from 'apps/marketplace/pages/create-shipment/schema/EquipmentDetailsSchema/EquipmentReeferSchema'
import { getEquipmentAttributeErrorMessage } from 'apps/marketplace/pages/create-shipment/utils'
import { REEFER_FLOW_OPTIONS } from 'apps/marketplace/utils/constants/graphqlEquipment'
import { TReeferSchemaErrors } from '../types'
import { useReeferEquipmentFormSectionStyles } from '../useReeferEquipmentFormSectionStyles'

export interface IReeferFlowFormSectionProps {}

const ReeferFlowFormSection = memo<IReeferFlowFormSectionProps>(() => {
  const classes = useReeferEquipmentFormSectionStyles()
  /**
   * Form Context
   */
  const { control, errors } = useCreateShipmentFormContext()
  const { equipmentAttributes } = errors || {}
  const equipmentAttributesErrors = equipmentAttributes as TReeferSchemaErrors

  const getErrorMessage = (keyName: keyof TReeferSchemaErrors) => {
    return getEquipmentAttributeErrorMessage<TReeferSchema>(equipmentAttributesErrors, keyName)
  }
  const flowErrorMessage = getErrorMessage(IEquipmentAttributeTypes.flow)
  return (
    <div>
      <Typography variant='subtitle1'>Flow</Typography>
      <div className={classes.radioContainer}>
        <ControlledRadioGroupInput
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.flow}`}
          options={REEFER_FLOW_OPTIONS}
          RadioProps={{
            dataTest: 'flow-field',
          }}
        />
        {flowErrorMessage && (
          <FormHelperText className='Mui-error'>{flowErrorMessage}</FormHelperText>
        )}
      </div>
    </div>
  )
})

export default ReeferFlowFormSection
